import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { UserDashboardHeader } from './UserDashboardHeader';
import { UserDashboardPage } from './UserDashboardPage';
import { getUserPhase } from './utils';

const phaseNames = [
  '- -',
  'Identification',
  'Elimination',
  'Reintroduction',
  'Application',
];

export const UserDashboard = () => {
  const {
    state: { user },
  } = useDashboardPageState();
  const currentPhase = getUserPhase(user?.current_phase);
  const navigate = useNavigate();

  const handlePhaseDetailsClick = useCallback(() => {
    if (!user?.current_phase) return;

    navigate(`/dashboard/${currentPhase}`, {
      state: {
        phase: currentPhase,
        phaseName: phaseNames[currentPhase],
      },
    });
  }, [user?.current_phase, currentPhase, navigate]);

  const handlePhaseLink = useCallback(
    (phase, phaseName) => {
      navigate(`/dashboard/${phase}`, {
        state: {
          phase,
          phaseName,
        },
      });
    },
    [navigate]
  );

  return (
    <UserDashboardPage
      header={<UserDashboardHeader />}
      onPhaseDetailsClick={handlePhaseDetailsClick}
      onPhaseLinkClick={handlePhaseLink}
    />
  );
};
